import {
  Avatar,
  Box,
  Button,
  Typography,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import color from "../../components/utils/Colors";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUser } from "../../services/Context/UserContext";
import { ChildProfile, fetchParentDashboard } from "../../services/adminData";

export const ParentProfile: React.FC = () => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const [parentName, setParentName] = useState("");
  const [children, setChildren] = useState<ChildProfile[]>([]);

  useEffect(() => {
    if (!user?.id) return;
    setLoading(true);
    fetchParentDashboard(user.id)
      .then(({ parentName: name, children: childList }) => {
        setParentName(name || user.name || "Parent");
        setChildren(childList);
      })
      .finally(() => setLoading(false));
  }, [user?.id, user?.name]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleOpenChild = (child: ChildProfile) => {
    navigate("/child-progress", {
      state: { childId: child.id, childName: child.name },
    });
  };

  return (
    <Box
      sx={{
        p: 4,
        pt: 2,
        width: isSmallScreen ? "100%" : "90%",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        onClick={handleGoBack}
        sx={{
          margin: 0,
          position: "absolute",
          top: isSmallScreen ? "120px" : "140px",
          color: color.firstColor,
          fontSize: "16px",
          fontWeight: "bold",
          left: isSmallScreen ? 10 : 60,
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronLeft /> Back
      </Typography>

      <Typography
        sx={{
          color: color.firstColor,
          fontSize: isSmallScreen ? "14px" : "26px",
          fontWeight: "bold",
          textAlign: "center",
          width: "100%",
          mb: 2,
          mt: 1.5,
          pb: 3,
          borderBottom: "solid 2px",
          borderColor: color.borderColor,
        }}
      >
        G2I Parent Profile
      </Typography>

      <Box>
        <Box
          sx={{
            position: "relative",
            background: color.firstColor,
            borderRadius: "16px",
            height: "fit-content",
            my: 4,
          }}
        >
          <Box
            component="img"
            src="/assets/parent profile.svg"
            alt="Welcome Bar"
            sx={{ width: "100%", height: 200, objectFit: "contain" }}
          />
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              top: { xs: "24%", sm: "25%" },
              left: "3%",
              fontSize: "32px",
              fontWeight: "bold",
            }}
          >
            Welcome,
          </Typography>
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              left: "3%",
              maxWidth: "62%",
              fontSize: "22px",
              top: { xs: "54%", sm: "50%" },
            }}
          >
            {parentName}
          </Typography>
        </Box>

        <h2
          style={{
            color: color.textColor,
            textAlign: "center",
            width: "100%",
            paddingLeft: "10px",
            margin: "0px",
          }}
        >
          Child Profiles ({children.length})
        </h2>

        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress sx={{ color: color.firstColor }} />
          </Box>
        ) : children.length === 0 ? (
          <Typography sx={{ textAlign: "center", color: "#666", mt: 4 }}>
            No linked child profiles found yet.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
              mt: 4,
              alignItems: "center",
            }}
          >
            {children.map((item) => (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: "solid 2px",
                  borderRadius: 4,
                  borderColor: color.borderColor,
                  p: 2,
                  width: "200px",
                  gap: 2,
                }}
              >
                <Avatar
                  sx={{ width: "70px", height: "70px" }}
                  src={item.pfp}
                />
                <h4
                  style={{
                    color: color.textColor,
                    textAlign: "center",
                    width: "100%",
                    margin: "0px",
                  }}
                >
                  {item.name}
                </h4>
                <Button id="button1" onClick={() => handleOpenChild(item)}>
                  Go to Profile
                </Button>
              </Box>
            ))}
          </Box>
        )}

        {children.length > 0 && (
          <Box sx={{ display: "flex", width: "100%", mt: 4, mb: 4 }}>
            <Button
              id="button1"
              onClick={() => handleOpenChild(children[0])}
              sx={{
                borderRadius: "4px",
                fontSize: "22px",
                margin: "auto",
                mt: 4,
              }}
            >
              Show Child Progress
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
